import * as React from "react";
import './HRToolCard.pcss';

interface Props {
  title: string;
  children: any;
}

export const HRToolCard = (props:Props) =>
  <div className={"hr-tool-card"}>
    <h2 className={'level2'}>{props.title}</h2>
    <div className={"hr-card-body"}>
      {props.children}
    </div>
  </div>
;